import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import { DASHBOARDS_FORMS } from '../../../constants';
import { getComplianceHistrogramActionButtons } from '../actionButtons/complianceHistrogramActionButtons';
import { renderChartContent } from '../renderers/chartRenderer';
import { scheduleComplianceHistTransformer } from '../transformers/scheduleComplianceHistTransformer';

import type { WidgetConfig } from './types';

export const scheduleComplianceHistChartConfig: WidgetConfig = {
  collectionName: FSCollections.CHARTS,
  componentType: DASHBOARDS_FORMS.SCHEDULE_COMPLIANCE_HIST,
  op: API_OPERATIONS.COMPLIANCE_HISTOGRAM,

  buildParams: (queryParams, commonParams) => ({
    ...commonParams,
    userIds: queryParams.userIds,
    groupIds: queryParams.groupIds,
    scheduleIds: queryParams.scheduleIds,
    divisionIds: queryParams.divisionIds,
    templateIds: queryParams.templateIds,
    type: queryParams.type,
    valueType: queryParams.valueType,
    groupBy: queryParams.groupBy,
  }),

  transformData: scheduleComplianceHistTransformer,
  renderContent: renderChartContent,

  getActionButtons: getComplianceHistrogramActionButtons,
};
